var _path, _g, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 34,
    viewBox: "0 0 310 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1558_12234",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 142,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.223 0.739197H0V31.8419H141.223V0.739197Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1558_12234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.7484 0.739197H62.0645V31.8419H66.7484V0.739197Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7373 31.8427V27.0579H62.0645V31.8427H81.7373Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8675 4.32867H40.2832V18.2055H53.8675V4.32867Z",
    fill: "#00C98F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7684 4.32867H30.4453V18.2055H36.7684V4.32867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8675 21.7941H40.2832V28.2542H53.8675V21.7941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7684 21.7941H30.4453V28.2542H36.7684V21.7941Z",
    fill: "#406AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2825 2.17413H36.7695V28.2525H40.2825V2.17413Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4446 0.739197H26.9316V31.8419H30.4446V0.739197Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3782 0.739197H53.8652V31.8419H57.3782V0.739197Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.144 18.2046H27.166V21.7932H57.144V18.2046Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6763 0.739197H28.8066V4.32778H56.6763V0.739197Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9736 28.2524H28.8066V31.841H55.9736V28.2524Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8694 31.8419H85.0137L95.7618 0.739197H102.589L113.352 31.8419H107.498L99.2949 7.19931H99.0662L90.8694 31.8419ZM91.1106 19.4008H107.211V24.1856H91.1106V19.4008Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.102 31.8419V0.739197H122.488V15.0943H122.957L134.432 0.739197H141.137L129.515 14.6303L141.225 31.8419H134.667L125.767 18.4559L122.488 22.5111V31.8419H117.102Z",
    fill: "#272D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 31.8419V28.276L15.3698 5.52816H0V0.739197H22.2494V4.14116L6.79217 27.0571H22.2494V31.8419H0Z",
    fill: "#272D4E"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310 33.5231H301.95L288.487 13.1399V33.5231H280.438V0.476929H288.487L301.95 20.9543V0.476929H310V33.5231Z",
    fill: "#9CACC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M274.134 0.476929V33.5231H266.084V0.476929H274.134Z",
    fill: "#9CACC2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M259.824 0.476929V33.5231H251.775V13.7048L244.384 33.5231H237.888L230.45 13.6577V33.5231H222.4V0.476929H231.909L241.183 23.3551L250.363 0.476929H259.824Z",
    fill: "#9CACC2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.109 0.476929C203.593 0.476929 206.637 1.16735 209.241 2.5482C211.846 3.92904 213.855 5.87478 215.267 8.38541C216.711 10.8647 217.432 13.7362 217.432 17C217.432 20.2325 216.711 23.104 215.267 25.6146C213.855 28.1253 211.831 30.071 209.194 31.4518C206.59 32.8327 203.561 33.5231 200.109 33.5231H187.729V0.476929H200.109ZM199.591 26.5561C202.635 26.5561 205.005 25.7245 206.699 24.0612C208.394 22.3979 209.241 20.0442 209.241 17C209.241 13.9559 208.394 11.5865 206.699 9.89179C205.005 8.19712 202.635 7.34978 199.591 7.34978H195.778V26.5561H199.591Z",
    fill: "#9CACC2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.12 27.6859H160.786L158.809 33.5231H150.383L162.34 0.476929H171.66L183.617 33.5231H175.097L173.12 27.6859ZM171.048 21.4721L166.953 9.37398L162.905 21.4721H171.048Z",
    fill: "#9CACC2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminLogo);
export default __webpack_public_path__ + "static/media/adminLogo.70557e44776099cb65bffc3594a68068.svg";
export { ForwardRef as ReactComponent };